var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-wrap"},[_c('div',{staticClass:"login-txt"},[_vm._v("为了更好的体验")]),_vm._v(" "),_c('div',{staticClass:"login-txt"},[_vm._v("\n    微信一键登录，更方便，更安全\n  ")]),_vm._v(" "),_c('button',{staticClass:"login-button",attrs:{"disabled":_vm.loading},on:{"click":_vm.wxTestAuth}},[_vm._v("\n    "+_vm._s(_vm.loading ? '登录中...' : '微信登录')+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c79c18d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = null
// module chunks = 